<template>
<div class="pdIndex bgc">
    <div class="outbox"><div class="classes blod">基本信息</div></div>
    <div class="form padding-20">
        <el-form :model="item" :rules="rules" ref="formName" label-width="120px" class="demo-item" label-position="left" size="mini">
            <el-form-item label="开启分销主页">
                <div class="box">
                    <el-switch v-model="isopendispage" @change="switchStatus"></el-switch>
                    <el-tooltip content="当前活动扣除手续费和返现之后的实收金额" placement="top">
                        <div>
                            <i class="tip el-icon-info"></i>
                        </div>
                    </el-tooltip>
                </div>
            </el-form-item>
            <el-form-item label="商家头像" prop="shoplogoid.furl" required v-if="isopendispage">
                <div class="box">
                    <upload class="headImage image" :imgRule="imgRule" @setImage="getShoplogourl" :uploadType="uploadType" ref="shoplogourl"></upload>
                    <div class="el-upload__tip">建议尺寸120*120px，JPG、PNG格式，图片小于100KB</div>
                </div>
            </el-form-item>
            <el-form-item label="商家名称" prop="hostshopname" v-if="isopendispage">
                <el-input v-model.trim="item.hostshopname" placeholder="请输入运营者名称"></el-input>
            </el-form-item>
            <el-form-item label="商家简介" v-if="isopendispage">
                <el-input v-model.trim="item.shopdesp" placeholder="请输入运营者名称"></el-input>
            </el-form-item>
            <el-form-item label="主页背景" prop="mobshopbgurl" v-if="isopendispage">
                <div class="box">
                    <upload class="bgImage image" :imgRule="imgRule" @setImage="getMobshopbgurl" :uploadType="uploadType" ref="mobshopbgurl"></upload>
                    <div class="el-upload__tip">建议尺寸比例16:9的JPG、PNG格式， 图片小于2M。</div>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm">提交资料</el-button>
                <el-button @click="cancel">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</div>
</template>

<script>
import Upload from 'base/upload/upload'
import {mapGetters, mapActions} from 'vuex'
import {getHostDisMainPageInfo, uploadHostDisMainPageInfo} from '@/api/nationalDistribution'
import {formatFileInfo} from 'common/js/tools'
export default {
    name: 'pdIndex',
    data() {
        let checkShopImg = (rule, value, callback) => {
            if (!this.item.shoplogoid.furl) {
                callback(new Error('请选择商家头像'))
            } else {
                callback()
            }
        }
        return {
            isopendispage: false,
            item: {
                isopendispage: 0,
                hostshopname: '',
                mobshopbgid: '',
                shopdesp: '',
                shoplogoid: ''
            },

            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg,image/gif',
                size: 2,
                width: 0,
                height: 0
            },
            rules: {
                hostshopname: [
                    {required: true, message: '请输入商家名称', trigger: 'blur'},
                    {max: 10, message: '商家名称最多10个字', trigger: 'blur'}
                ],
                'shoplogoid.furl': [
                    {validator: checkShopImg, trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
        this._getView()
    },
    methods: {
        cancel() {
            this.$router.back()
        },
        switchStatus() {
            this.$nextTick(() => {
                this.$refs.shoplogourl.setImage(this.item.shoplogoid.furl)
                if (this.item.mobshopbgid.furl) this.$refs.mobshopbgurl.setImage(this.item.mobshopbgid.furl)
            })
        },
        getShoplogourl(img) {
            this.item.shoplogoid = img
        },
        getMobshopbgurl(img) {
            this.item.mobshopbgid = img
        },
        submitForm() {
            this.$refs.formName.validate((valid) => {
                if (valid) {
                    this.$confirm('确定要提交资料吗？', '提交资料', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._editObject(this.item)
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
                }
            })
        },
        _editObject(obj) {
            this.setLoading(true)
            uploadHostDisMainPageInfo({
                data: {
                    isopendispage: this.isopendispage ? 1 : 0,
                    hostshopname: obj.hostshopname,
                    mobshopbgid: formatFileInfo(obj.mobshopbgid),
                    shopdesp: obj.shopdesp,
                    shoplogoid: formatFileInfo(obj.shoplogoid)
                },
                success: data => {
                    this.$message.success('操作成功')
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getHostDisMainPageInfo({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.isopendispage = !!data.data.isopendispage
                    this.item = data.data
                    if (this.isopendispage) {
                        this.$nextTick(() => {
                            this.$refs.shoplogourl.setImage(this.item.shoplogoid.furl)
                            if (this.item.mobshopbgid.furl) this.$refs.mobshopbgurl.setImage(this.item.mobshopbgid.furl)
                        })
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['loading', 'shop'])
    },
    components: {
        Upload
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
@import "~common/scss/index";
.pdIndex {
    .outbox{
        height: 60px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid $line;
        .classes{
            height: 14px;
            margin-bottom: 0;
        }
    }
    .form{
        margin-top: 0;
        .upload-image{
            .el-form-item__content{
                @include flexBox(space-between)
            }
        }
        .box {
            @include flexBox(flex-start);
            margin-bottom: 10px;
            .headImage{
                .avatar-uploader{
                    width: 180px;
                    height: 180px;
                    margin-right: 30px;
                }
            }
            .bgImage{
                .avatar-uploader{
                    width: 320px;
                    height: 180px;
                    margin-right: 30px;
                }
            }
            .tip{
                margin-left: 12px;
            }
        }
    }
}
</style>
